module.exports = __webpack_public_path__ + "img/Work.f4fd8ebf.svg";